import { isEmpty, omit } from 'lodash'

import { getChangedValues } from 'utils/formik'
import { posAccountsUtils } from 'components/PosAccounts/utils'

export const getPreparedAttendantsData = (
  values,
  initialValues,
  employeeId,
  orgName,
  name,
  uuid
) => {
  const changedValues = getChangedValues(values, initialValues)
  const changedValuesWithoutRole = omit(changedValues, 'role')

  if (isEmpty(changedValuesWithoutRole)) {
    return null
  }

  return {
    ...changedValuesWithoutRole,
    employeeId: posAccountsUtils.getValidEmployeeId(
      employeeId,
      orgName,
      name
    ),
    uuid: uuid,
  }
}

export const apiDataPreparation = {
  getPreparedAttendantsData,
}
